import { render, staticRenderFns } from "./BlockType23BigRow.vue?vue&type=template&id=60fbb0bd&scoped=true"
import script from "./BlockType23BigRow.vue?vue&type=script&lang=ts"
export * from "./BlockType23BigRow.vue?vue&type=script&lang=ts"
import style0 from "./BlockType23BigRow.vue?vue&type=style&index=0&id=60fbb0bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fbb0bd",
  null
  
)

export default component.exports